import { Box, Container } from '@mui/material'

import { styles } from './ViewMaster.styles'

export const TEST_ID = 'view-master'
const ViewMaster = () => {
	return (
		<Box>
			<Container
				data-testid={`${TEST_ID}-container`}
				maxWidth="md"
				sx={styles.container}
			>
				<h1>View Master content goes here.</h1>
			</Container>
		</Box>
	)
}
export default ViewMaster
